"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryCursorContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _victoryCursorContainer = require("victory-cursor-container");
var _victoryLabel = require("./victory-label");
var _victoryContainer = require("./victory-container");
var _lineSegment = require("./victory-primitives/line-segment");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const VictoryCursorContainer = initialProps => {
  const props = (0, _victoryCursorContainer.useVictoryCursorContainer)({
    ...initialProps,
    cursorLabelComponent: initialProps.cursorLabelComponent ?? /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    cursorComponent: initialProps.cursorComponent ?? /*#__PURE__*/_react.default.createElement(_lineSegment.LineSegment, null)
  });
  return /*#__PURE__*/_react.default.createElement(_victoryContainer.VictoryContainer, props);
};
exports.VictoryCursorContainer = VictoryCursorContainer;
VictoryCursorContainer.role = "container";
VictoryCursorContainer.defaultEvents = initialProps => {
  const props = {
    ..._victoryCursorContainer.VICTORY_CURSOR_CONTAINER_DEFAULT_PROPS,
    ...initialProps
  };
  const createEventHandler = (handler, disabled) =>
  // eslint-disable-next-line max-params
  (event, targetProps, eventKey, context) => disabled || props.disable ? {} : handler(event, {
    ...props,
    ...targetProps
  }, eventKey, context);
  return [{
    target: "parent",
    eventHandlers: {
      onTouchStart: createEventHandler(_victoryCursorContainer.CursorHelpers.onMouseMove),
      onTouchMove: createEventHandler(_victoryCursorContainer.CursorHelpers.onMouseMove),
      onTouchEnd: createEventHandler(_victoryCursorContainer.CursorHelpers.onTouchEnd)
    }
  }];
};